// extracted by mini-css-extract-plugin
export default {"center":"HsCodeDetailsTree-module_center__x7yCa","tree":"HsCodeDetailsTree-module_tree__vuUke"};